import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import {
  WalletIcon,
  ChevronDownIcon,
  CubeIcon,
  PhotoIcon,
  ArrowsRightLeftIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { useWalletStore } from '../store/walletStore';

export default function WalletConnect() {
  const { address, isConnected, balance, connect, disconnect } = useWalletStore();

  const handleConnect = async () => {
    try {
      await connect();
    } catch (error) {
      console.error('Failed to connect wallet:', error);
    }
  };

  if (isConnected && address) {
    return (
      <Menu as="div" className="relative">
        <Menu.Button className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-vextaris-dark border border-vextaris-purple/30 text-white hover:border-vextaris-purple/60 transition-colors text-sm font-medium">
          <WalletIcon className="h-4 w-4 text-vextaris-lime" />
          <span>{address.slice(0, 6)}...{address.slice(-4)}</span>
          <ChevronDownIcon className="h-4 w-4 text-gray-400" />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-xl bg-vextaris-dark border border-vextaris-purple/30 shadow-lg focus:outline-none z-50">
            <div className="px-4 py-3 border-b border-vextaris-purple/20">
              <p className="text-xs text-gray-400">Connected</p>
              <p className="text-sm font-semibold text-white font-mono">{address.slice(0, 12)}...{address.slice(-4)}</p>
            </div>

            <div className="py-1">
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/my-tokens"
                    className={`flex items-center space-x-3 px-4 py-2 text-sm ${active ? 'bg-vextaris-purple/10 text-white' : 'text-gray-300'}`}
                  >
                    <CubeIcon className="h-4 w-4" />
                    <span>My Tokens</span>
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/my-tokens?tab=nfts"
                    className={`flex items-center space-x-3 px-4 py-2 text-sm ${active ? 'bg-vextaris-purple/10 text-white' : 'text-gray-300'}`}
                  >
                    <PhotoIcon className="h-4 w-4" />
                    <span>My NFTs</span>
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/bridge?tab=history"
                    className={`flex items-center space-x-3 px-4 py-2 text-sm ${active ? 'bg-vextaris-purple/10 text-white' : 'text-gray-300'}`}
                  >
                    <ArrowsRightLeftIcon className="h-4 w-4" />
                    <span>Bridge History</span>
                  </Link>
                )}
              </Menu.Item>
            </div>

            <div className="border-t border-vextaris-purple/20 py-1">
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={disconnect}
                    className={`flex items-center space-x-3 w-full px-4 py-2 text-sm ${active ? 'bg-red-500/10 text-red-400' : 'text-red-400'}`}
                  >
                    <ArrowRightOnRectangleIcon className="h-4 w-4" />
                    <span>Disconnect</span>
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    );
  }

  return (
    <button
      onClick={handleConnect}
      className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-gradient-vextaris text-white hover:opacity-90 transition-opacity text-sm font-medium"
    >
      <WalletIcon className="h-5 w-5" />
      <span>Connect Wallet</span>
    </button>
  );
}
